module.exports = __webpack_public_path__ + "static/media/rocketBanner.5a7086ac.gif";